import { render, staticRenderFns } from "./AccountOrganisationAdd.vue?vue&type=template&id=4c2723ef&"
import script from "./AccountOrganisationAdd.vue?vue&type=script&lang=ts&"
export * from "./AccountOrganisationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2723ef')) {
      api.createRecord('4c2723ef', component.options)
    } else {
      api.reload('4c2723ef', component.options)
    }
    module.hot.accept("./AccountOrganisationAdd.vue?vue&type=template&id=4c2723ef&", function () {
      api.rerender('4c2723ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/organisations/AccountOrganisationAdd.vue"
export default component.exports